import { NavLink, useNavigate } from 'react-router-dom';
import { getToken, isAdmin, getUserEmail } from '../utils/auth';
import { useState } from 'react';

import {
  HomeIcon,
  UserCircleIcon,
  ArrowRightStartOnRectangleIcon,
  Bars3Icon,
  XMarkIcon
} from '@heroicons/react/24/outline';

export default function Navbar() {
  const navigate = useNavigate();
  const token = getToken();
  const userIsAdmin = isAdmin(token);
  const userEmail = getUserEmail(token);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  function handleLogout() {
    localStorage.removeItem('token');
    navigate('/login');
  }

  function toggleMobileMenu() {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  }

  return (
    <div className="bg-white shadow-sm">
      {/* Desktop Navbar */}
      <div className="hidden md:flex justify-between items-center px-6 py-4">
        <div className="flex items-center">
          <NavLink to="/dashboard" className="flex items-center">
            <img src="/logo.png" alt="Brand Logo" className="w-auto h-8" />
          </NavLink>
        </div>

        <div className="text-center">
          <div className="font-bold text-[#1688BE] text-lg uppercase tracking-wide">
            Welcome 🎉
          </div>
          <div className="max-w-xs text-gray-500 text-sm truncate">
            {userEmail}
          </div>
        </div>

        <div className="flex items-center gap-2">
          <ul className="bg-base-200 rounded-box menu menu-horizontal">
            <li>
              <NavLink
                to="/dashboard"
                className={({ isActive }) =>
                  `tooltip hover:bg-gray-300 transition-colors p-2 rounded-lg ${isActive ? 'bg-gray-300' : ''}`
                }
                data-tip="Dashboard"
                end
              >
                <HomeIcon className="w-5 h-5" />
              </NavLink>
            </li>
            {userIsAdmin && (
              <li>
                <NavLink
                  to="/admin"
                  className={({ isActive }) =>
                    `tooltip hover:bg-gray-300 transition-colors p-2 rounded-lg ${isActive ? 'bg-gray-300' : ''}`
                  }
                  data-tip="Admin"
                >
                  <UserCircleIcon className="w-5 h-5" />
                </NavLink>
              </li>
            )}
            <li>
              <button
                onClick={handleLogout}
                className="hover:bg-gray-300 p-2 rounded-lg transition-colors tooltip"
                data-tip="Logout"
              >
                <ArrowRightStartOnRectangleIcon className="w-5 h-5" />
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Mobile Navbar */}
      <div className="md:hidden">
        {/* Mobile Header */}
        <div className="flex justify-between items-center px-4 py-3">
          <NavLink to="/dashboard" className="flex items-center">
            <img
              src="/logo.png"
              alt="Brand Logo"
              className="w-auto h-8 object-contain"
            />
          </NavLink>

          <button
            onClick={toggleMobileMenu}
            className="hover:bg-gray-100 -mr-1 p-2 rounded-lg transition-colors"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <XMarkIcon className="w-7 h-7 text-gray-600" />
            ) : (
              <Bars3Icon className="w-7 h-7 text-gray-600" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="bg-gray-50 border-gray-200 border-t">
            <div className="space-y-3 px-4 py-3">
              {/* User Email */}
              <div className="bg-white px-3 py-2 border border-gray-200 rounded-lg">
                <div className="text-gray-500 text-sm">Welcome 🎉</div>
                <div className="font-medium text-gray-900 text-sm break-all">
                  {userEmail}
                </div>
              </div>

              <NavLink
                to="/dashboard"
                onClick={() => setIsMobileMenuOpen(false)}
                className={({ isActive }) =>
                  `flex items-center gap-3 p-3 rounded-lg transition-colors ${
                    isActive
                      ? 'bg-[#1688BE] text-white'
                      : 'hover:bg-gray-200 text-gray-700'
                  }`
                }
                end
              >
                <HomeIcon className="w-5 h-5" />
                <span className="font-medium">Dashboard</span>
              </NavLink>

              {userIsAdmin && (
                <NavLink
                  to="/admin"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-3 p-3 rounded-lg transition-colors ${
                      isActive
                        ? 'bg-[#1688BE] text-white'
                        : 'hover:bg-gray-200 text-gray-700'
                    }`
                  }
                >
                  <UserCircleIcon className="w-5 h-5" />
                  <span className="font-medium">Admin Panel</span>
                </NavLink>
              )}

              <button
                onClick={() => {
                  handleLogout();
                  setIsMobileMenuOpen(false);
                }}
                className="flex items-center gap-3 hover:bg-gray-200 p-3 rounded-lg w-full text-gray-700 text-left transition-colors"
              >
                <ArrowRightStartOnRectangleIcon className="w-5 h-5" />
                <span className="font-medium">Logout</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
